import { configureStore } from '@reduxjs/toolkit'
import loginSlice from './login'
import userProfileReducer from './profileData'
import jobCardReducer from './applyCards'
import jobsReducer from './appliedJobs';
import referralReducer from './referralData';
import emailsReducer from './emails'
import monitoringReducer from './monitoring';
import answerReviewsReducer from './answerReviews';
import scoreboardReducer from './scoreboard';


export const appReducers = {
  loginUser: loginSlice,
  profileData: userProfileReducer,
  jobCards: jobCardReducer,
  appliedJobs: jobsReducer,
  referralData: referralReducer,
  emails: emailsReducer,
  monitoring: monitoringReducer,
  answerReviews: answerReviewsReducer,
  scoreboard: scoreboardReducer,
};

/**
 * A store with the app's real reducers, separate from the singleton below. The dev-only
 * preview harnesses render real components against scripted data, and dispatching that data
 * into the store the rest of the app shares would leave harness values (a premium plan, a
 * flipped profile flag) sitting in state for whatever the user opens next.
 */
export const createAppStore = (preloadedState) =>
  configureStore({ reducer: appReducers, preloadedState });

const store = createAppStore();

export default store;
